<template>
  <div class="login_page">
    <img
      class="goback"
      :class="[$store.state.isMirroring && 'mirror']"
      src="@/assets/back_new.png"
      alt=""
      :style="{ top: `calc(0.2rem + ${$store.state.statusBarHeight}px)` }"
      @click="goback"
    />
    <!-- 背景 -->
    <img class="top_bg" src="@/assets/top_bg.png" alt="" />
    <img class="bottom_bg" src="@/assets/bottom_bg_right.png" alt="" />
    <!-- 标题 -->
    <div class="title">
      <div>
        <img v-show="loginType == 'PHONE'" class="title_icon" src="@/assets/phone_text.png" alt="" />
        <img v-show="loginType == 'EMAIL'" class="title_icon" src="@/assets/email_text.png" alt="" />
      </div>
      <div class="sub_title">
        <div
          v-show="loginType == 'PHONE' && toWhatsapp && !showSetPwd && !showSlideVerification"
          class="to_whatsapp_text"
        >
          {{ $t('redesign.sendToWhatsapp') }}
        </div>
        <div class="account">
          <span v-show="loginType == 'PHONE'">+{{ areaCode }}</span>
          <span>{{ account }}</span>
        </div>
      </div>
    </div>
    <div class="login_box">
      <!-- 滑块验证码 -->
      <div v-show="!showSetPwd && showSlideVerification" id="slideVerification" class="slide_verification"></div>
      <!-- 验证码输入框 -->
      <div v-show="!showSetPwd && !showSlideVerification" class="input_area">
        <CommonInput
          v-model="smsCode"
          type="tel"
          inputmode="numeric"
          :placeholder="loginType == 'PHONE' ? $t('common.smsCode') : $t('common.emailCode')"
          :max-length="VALID_CODE_LENGTH"
          :on-focus="onFocus"
          :on-blur="onBlur"
        >
          <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="resend">
            {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
          </div>
        </CommonInput>
      </div>
      <!-- 密码设置 -->
      <div v-show="showSetPwd && !showSlideVerification" class="input_area">
        <!-- 国家选择 -->
        <router-link
          class="select_country"
          v-show="loginType == 'EMAIL'"
          :to="{
            name: 'Country',
            query: { redirect: 'Register' },
            params: {
              loginType: loginType,
              data: { account: account, registerType: loginType, verified: true }
            }
          }"
          replace
        >
          <img v-if="!country" class="select_country_img" src="@/assets/common_country.png" alt="" />
          <img v-if="country" class="select_country_img" :src="country.countryFlagUrl" />
          <span v-if="!country" class="select_country_info">
            {{ $t('common.countrySelect') }}
          </span>
          <span v-if="country" class="select_country_info">
            {{ country.countryName }}
          </span>
          <img
            class="select_country_arrow"
            src="@/assets/common_guide_arrow.png"
            :style="{ transform: `rotate(${$store.state.isMirroring ? '180deg' : '0'})` }"
          />
        </router-link>
        <div v-show="loginType == 'EMAIL' && areaCode" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('common.countryUnmodifiedNote') }}
        </div>
        <!-- 输入密码 -->
        <CommonInput
          class="pwd_input"
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t('loginAndRegister.pwdPlaceholder')"
          show-clear
          :on-focus="focusPasswordInput"
          :on-blur="inputBlur"
        >
          <img
            v-show="!showPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
          <img
            v-show="showPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
        </CommonInput>
        <div v-show="passwordWarning" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.pwdNote') }}
        </div>
        <!-- 再次输入 -->
        <CommonInput
          class="pwd_input"
          v-model="confirmPassword"
          :type="showSecondPassword ? 'text' : 'password'"
          :placeholder="$t('loginAndRegister.reenterPwdPlaceholder')"
          show-clear
          :on-focus="focusPasswordInput"
          :on-blur="onBlur"
        >
          <img
            v-show="!showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
          <img
            v-show="showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
        </CommonInput>
        <div v-show="confirmPassword" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.reenterPwdNote') }}
        </div>
      </div>
      <!-- <CommonBtn
        v-show="!showSlideVerification"
        class="next_btn"
        :text="$t('common.next')"
        :disabled="showSetPwd ? !canNext : !smsCode || smsCode.length !== VALID_CODE_LENGTH"
        :on-click="showSetPwd ? createAccount : checkSmsCode"
      ></CommonBtn> -->
      <CommonBtn
        v-show="!showSlideVerification"
        class="next_btn"
        :text="$t('common.next')"
        :disabled="showSetPwd ? (!canNext || registering) : !smsCode"
        :on-click="showSetPwd ? createAccount : checkSmsCode"
      ></CommonBtn>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { Toast } from 'vant'
import CommonInput from '@/components/CommonInput.vue'
import CommonBtn from '@/components/CommonBtn.vue'
import throttle from 'lodash/throttle'
import { getBrowserInfo } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'
import { postReportLog } from '../utils/log'
import { parseCountryFromParams, resolveCountry, syncSelectedCountryOnAreaCodeChange, flattenCountryList } from '@/utils/country'

export default {
  name: 'Register',
  components: { CommonInput, CommonBtn },
  data() {
    return {
      VALID_CODE_LENGTH,
      phone: '',
      password: '',
      confirmPassword: '',
      comparePassword: false,
      canNext: false,
      passwordError: false,
      isFormat: false,
      passwordWarning: false,
      account: '',
      areaCode: '',
      smsCode: '',
      count: 59,
      msgValidating: false,
      firstSendMsg: true,
      smsShow: false,
      passwordInputShow: true,
      loginType: '',
      showPassword: false,
      showSecondPassword: false,
      showSlideVerification: false,
      showSetPwd: false,
      countryList: [],
      selectedCountry: null,
      toWhatsapp: false,
      registering: false
    }
  },
  computed: {
    country() {
      return resolveCountry({
        selectedCountry: this.selectedCountry,
        countryList: this.countryList,
        areaCode: this.areaCode
      })
    }
  },
  watch: {
    phone(value) {
      this.phone = value.replace(/\D/g, '')
      this.change()
    },
    password() {
      this.change()
    },
    confirmPassword() {
      this.change()
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.checkSmsCode()
      }
    },
    areaCode(val) {
      this.selectedCountry = syncSelectedCountryOnAreaCodeChange(this.selectedCountry, this.countryList, val)
    },
    countryList(list) {
      if (list.length && this.areaCode) {
        this.selectedCountry = syncSelectedCountryOnAreaCodeChange(this.selectedCountry, list, this.areaCode)
      }
    },
    '$route.params'() {
      this.applyCountryFromRoute()
    }
  },
  created() {
    let paramsData = this.$route.params
    this.account = paramsData.data ? paramsData.data.account : paramsData.account
    this.areaCode = paramsData.areaCode
    this.loginType = paramsData.data ? paramsData.data.registerType : paramsData.registerType
    this.selectedCountry = parseCountryFromParams(paramsData)
    this.password = this.$route.params.data ? this.$route.params.data.password : ''
    // 曝光埋点
    postReportLog({
      log_id: '440',
      extra: {
        page: 'register',
        login_type: this.loginType
      }
    })
    if (!this.loginType || !this.account) {
      this.goback()
    }
    this.getCountryList()
    this.initSlideVerification()
    if (this.$route.params.data && this.$route.params.data.verified) {
      this.showSetPwd = true
      this.showSlideVerification = false
      if (!this.areaCode) {
        // 没有选择国家直接返回的情况
        this.getAreaCodeByIP()
      }
    } else {
      if (this.loginType === 'EMAIL') {
        this.getAreaCodeByIP()
        this.showSlideVerification = false
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    }
  },
  methods: {
    bindLogExtra(extra) {
      return {
        bind_type: this.loginType === 'EMAIL' ? 'email' : 'phone',
        bind_account:
          this.loginType === 'EMAIL' ? this.account : this.areaCode + '' + this.account,
        ...extra
      }
    },
    reportRegisterFail(errorCode, failReason) {
      postReportLog({
        log_id: '477',
        extra: this.bindLogExtra({
          step: '7',
          action: 'register_result',
          result: 'fail',
          error_code: errorCode,
          fail_reason: failReason
        })
      })
    },
    reportCodeSend(result, errorCode, failReason) {
      postReportLog({
        log_id: '477',
        extra: this.bindLogExtra({
          step: '4',
          action: 'code_send',
          result,
          error_code: errorCode || '',
          fail_reason: failReason || ''
        })
      })
    },
    applyCountryFromRoute() {
      const country = parseCountryFromParams(this.$route.params)
      if (country) {
        this.selectedCountry = country
        this.areaCode = country.areaCode
      }
    },
    onFocus() {
      this.updatePageStyle('focus')
    },
    onBlur() {
      this.updatePageStyle('blur')
    },
    updatePageStyle(event) {
      const title = document.getElementById('title')
      if (title) {
        title.style.marginTop = event === 'focus' ? '0.82rem' : '1.42rem'
      }
    },
    getAreaCodeByIP() {
      this.$http.get(window.serverPath + '/api/auth/getIpDetail').then((res) => {
        if (res.data.code === '200') {
          this.areaCode = res.data.data.areaCode
        }
      })
    },
    getCountryList() {
      this.$http.get(window.serverPath + '/api/country/getNewAreaCodeList').then((res) => {
        if (res.data.code === '200') {
          this.countryList = flattenCountryList(res.data.data)
        }
      })
    },
    goback() {
      if (this.smsShow) {
        this.passwordInputShow = true
        this.smsShow = false
      } else {
        this.$router.back()
      }
    },
    resend() {
      if (this.msgValidating) {
        return
      }
      if (this.loginType === 'EMAIL') {
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    },
    initSlideVerification() {
      const $this = this
      initSMCaptcha(
        {
          organization: '90I5YRBCdvRoD8mXmETq',
          domains: ['captcha-xjp.fengkongcloud.cn'], // 新加坡
          product: 'embed', // 展现形式
          appendTo: 'slideVerification', // 指定 DOM 节点
          mode: 'slide', // 验证码模式
          lang: 'en',
          width: 295,
          style: {
            slideBar: {
              color: '#3FBB70',
              successColor: '#3FBB70',
              border: 'none',
              process: {
                background: '#3FBB7033',
                failBackground: '#ff4c6233'
              },
              button: {
                boxShadow: 'none',
                background: '#3FBB70',
                failBackground: '#ff4c62'
              }
            }
          }
        },
        (SMCaptcha) => {
          SMCaptcha.onReady((_rootEl, params) => {
            // params中包含type字段，'init'-启动后 | 'refresh'-手动刷新图片后 | 'afterFail'-验证失败后s
            if (params.type === 'init') {
              $this.SMCaptchaValue = SMCaptcha
            }
          })
          SMCaptcha.onSuccess(function (data) {
            if (data.pass) {
              $this.showSlideVerification = false
              SMCaptcha.reset()
              $this.sendSmsCode(data.rid)
            }
          })
        }
      )
    },
    checkSmsCode: throttle(
      function () {
        // 暂时去掉验证码长度限制
        // if (!this.smsCode || this.smsCode.length !== this.VALID_CODE_LENGTH) {
        //   return
        // }
        if (!this.smsCode) return
        const url = this.loginType !== 'EMAIL' ? '/api/auth/checkSmsCode/SIGN_UP' : '/api/auth/checkEmailCode/SIGN_UP'
        const params =
          this.loginType !== 'EMAIL'
            ? { validCode: this.smsCode, phone: this.areaCode + '' + this.account }
            : { validCode: this.smsCode, email: this.account }
        this.$http
          .post(window.serverPath + url, params)
          .then((res) => {
            if (res.data.code === '200') {
              // 绑定钱包流程埋点 - step4 验证码校验成功
              postReportLog({
                log_id: '477',
                extra: this.bindLogExtra({
                  step: '4',
                  action: 'code_verify',
                  result: 'success',
                  error_code: ''
                })
              })
              this.$store.commit('setSecurityToken', res.data.data.securityToken)
              this.showSetPwd = true
            } else {
              postReportLog({
                log_id: '477',
                extra: this.bindLogExtra({
                  step: '4',
                  action: 'code_verify',
                  result: 'fail',
                  error_code: (res.data && res.data.code) || 'wrong_code',
                  fail_reason: 'code_wrong'
                })
              })
              Toast({
                message: this.$t('accountSecurity.wrongCodeToast')
              })
            }
          })
          .catch((_err) => {
            postReportLog({
              log_id: '477',
              extra: this.bindLogExtra({
                step: '4',
                action: 'code_verify',
                result: 'fail',
                error_code: 'network',
                fail_reason: 'network'
              })
            })
            console.log('异常')
          })
      },
      5000,
      { trailing: false }
    ),
    createAccount: throttle(
      function () {
        // 前置校验
        if (!this.areaCode) {
          Toast({
            message: this.$t('loginAndRegister.chooseCountryNote')
          })
          return
        }
        this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
        if (this.confirmPassword === this.password) {
          this.comparePassword = true
        } else {
          Toast({
            message: this.$t('loginAndRegister.pwdInconsistentToast')
          })
          return
        }
        if (!this.canNext || this.passwordError || !this.comparePassword) {
          Toast({
            message: this.$t('loginAndRegister.pwdNote')
          })
          return
        }
        // 锁定按钮，防止 throttle 窗口内重复点击
        this.registering = true
        // 绑定钱包流程埋点 - step5 填写密码并点击 Next（点击意向，不是注册成功）
        postReportLog({
          log_id: '477',
          extra: this.bindLogExtra({
            step: '5'
          })
        })
        // 开始注册流程
        localStorage.removeItem('paramsData')
        const params = { type: 0 }
        params.password = md5(this.password)
        params.areaCode = this.areaCode
        params.countryNo = this.country.countryNo
        params.registerType = this.loginType
        params.securityToken = this.$store.state.securityToken
        if (this.loginType === 'EMAIL') {
          params.loginId = this.account
          params.email = this.account
        } else {
          params.loginId = this.areaCode + '' + this.account
          params.phone = this.areaCode + '' + this.account
        }
        params.device = getBrowserInfo() // 用户使用浏览器埋点
        this.$http
          .post(window.serverPath + '/api/auth/newRegister', params)
          .then((res) => {
            if (res.data.code === '200') {
              postReportLog({
                log_id: '477',
                extra: this.bindLogExtra({
                  step: '7',
                  action: 'register_result',
                  result: 'success',
                  error_code: ''
                })
              })
              const $this = this
              Toast.success({
                message: this.$t('loginAndRegister.createSuccessToast'),
                onClose: function () {
                  const params1 = {
                    type: 0,
                    loginId: params.loginId,
                    password: params.password,
                    loginType: $this.loginType,
                    apptype: localStorage.getItem('apptype'),
                    device: getBrowserInfo() // 用户使用浏览器埋点
                  }
                  $this.$http
                    .post(window.serverPath + '/api/auth/newLogin', params1)
                    .then((res) => {
                      if (res.data.code === '200') {
                        localStorage.setItem('token', res.data.data.token)
                        sessionStorage.setItem('firstLogin', 1)
                        $this.getUserInfo(res.data.data.token)
                      }
                    })
                    .catch((_err) => {
                      console.log('error', _err)
                    })
                }
              })
            } else if (res.data.code === '60002') {
              this.registering = false
              this.reportRegisterFail(res.data.code, 'already_exists')
              Toast({
                message: res.data.message
              })
            } else if (res.data.code === '100004') {
              this.registering = false
              this.reportRegisterFail(res.data.code, 'register_fail')
              Toast({
                message: res.data.message
              })
            } else {
              this.registering = false
              this.reportRegisterFail((res.data && res.data.code) || 'unknown', 'register_fail')
              Toast({
                message: this.$t('loginAndRegister.registerFailToast')
              })
            }
          })
          .catch((_err) => {
            this.registering = false
            this.reportRegisterFail('network', 'register_fail')
            console.log('异常')
          })
      },
      5000,
      { trailing: false }
    ),
    change() {
      if (this.password && this.confirmPassword && this.country) {
        this.canNext = true
      } else {
        this.canNext = false
      }
    },
    focusPasswordInput() {
      this.passwordError = false
      this.onFocus()
    },
    inputBlur() {
      this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
      if (this.passwordError) {
        this.passwordWarning = true
      } else {
        this.passwordWarning = false
      }
      this.onBlur()
    },
    sendSmsCode(rid = '') {
      if (this.msgValidating) {
        return
      }
      let isEmail = this.loginType === 'EMAIL'
      const $this = this
      const phone = this.areaCode + '' + this.account
      const email = this.account
      const url =
        window.serverPath + (isEmail ? '/api/auth/getNewEmailCode/SIGN_UP' : '/api/auth/getNewSmsCode/SIGN_UP')
      const params = isEmail ? { email: email } : { phone: phone, areaCode: this.areaCode, rid }
      if (phone || email) {
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              this.reportCodeSend('success')
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.toWhatsapp = res.data.data === 'WhatsApp'
              const interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval(interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
            } else if (res.data.code === '40001') {
              this.reportCodeSend('fail', res.data.code, isEmail ? 'email_send' : 'sms_send')
              Toast({
                message: this.$t('loginAndRegister.userNotExistToast')
              })
            } else if (res.data.code === '100004') {
              this.reportCodeSend('fail', res.data.code, isEmail ? 'email_send' : 'sms_send')
              Toast({
                message: res.data.message
              })
            } else {
              this.reportCodeSend(
                'fail',
                (res.data && res.data.code) || 'unknown',
                isEmail ? 'email_send' : 'sms_send'
              )
              Toast({
                message: res.data.message
              })
            }
          })
          .catch((_err) => {
            this.reportCodeSend('fail', 'network', 'network')
            console.log('异常')
            $this.msgValidating = false
            $this.count = 59
          })
      } else {
        this.reportCodeSend('fail', 'empty', isEmail ? 'email_send' : 'sms_send')
        Toast({ message: this.$t('loginAndRegister.phoneIncorrectToast') })
      }
    },
    getUserInfo() {
      const $this = this
      this.$http
        .get(window.serverPath + '/api/user/info')
        .then((res) => {
          if (res.data.code === '200') {
            let store = localStorage.getItem('store') || '{}'
            $this.$store.replaceState(
              Object.assign({}, this.$store.state, {
                ...JSON.parse(store),
                userInfo: res.data.data
              })
            )
            localStorage.setItem('store', JSON.stringify(this.$store.state))
            // sessionStorage中存储了重定向信息则重定向
            const redirectInfo = sessionStorage.getItem('redirectInfo')
            if (redirectInfo) {
              $this.$router.replace(redirectInfo)
              sessionStorage.removeItem('redirectInfo')
            } else {
              $this.$router.replace({
                name: 'Home'
              })
            }
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_page {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #d9ffe8 0.35%, rgba(255, 255, 255, 0) 52.27%), #f5fff9;
  position: relative;
  padding: 0 0.24rem;
  box-sizing: border-box;
  overflow: hidden;
}

.goback {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  left: 0.18rem;
  z-index: 2;
}

.goback.mirror {
  left: auto;
  right: 0.18rem;
  transform: rotate(180deg);
}

.top_bg {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 1;
}

.bottom_bg {
  position: absolute;
  bottom: 0;
  width: 70%;
  right: 0;
  z-index: 1;
}

.title {
  width: 100%;
  margin: 1.42rem 0 0.24rem;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.title_icon {
  height: 0.36rem;
  display: block;
}

.sub_title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.to_whatsapp_text {
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  color: #3fbb70;
  margin-top: 0.04rem;
  font-weight: 600;
  line-height: 0.22rem;
  flex-shrink: 0;
  margin-inline-end: 0.04rem;
}

.account {
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  color: #3fbb70;
  margin-top: 0.04rem;
  font-weight: 600;
  line-height: 0.22rem;
  display: flex;
  direction: ltr;
}

.login_box {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input_area {
  width: 100%;
}

.next_btn {
  margin-top: 0.52rem;
}

.slide_verification {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.select_country {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 0.08rem;
  height: 0.48rem;
  background: linear-gradient(90deg, rgba(67, 215, 125, 0.15) 0%, rgba(63, 187, 112, 0.15) 100%);
  display: flex;
  align-items: center;
  position: relative;
}

.select_country_info {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
}

.select_country_img {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 0.21rem;
  overflow: hidden;
  background-color: #f5f5f5;
  margin-inline-end: 0.12rem;
}

.select_country_arrow {
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  right: 0.16rem;
  top: 0.14rem;
}

.pwd_input {
  margin-top: 0.12rem;
}

.country_toast {
  width: 100%;
  display: flex;
  font-size: 0.12rem;
  font-weight: 400;
  color: #ff840b;
  margin: 0.06rem 0 0.12rem;
  align-items: center;
}

.note_icon {
  width: 0.12rem;
  height: 0.12rem;
  margin-inline-end: 0.02rem;
}

.password_status_icon {
  margin-inline-start: 0.2rem;
  width: 0.2rem;
  height: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue